//#region src/platform.is-node.ts
/**
* determine if the script is running within the node.js server side layer
*/
function isPlatformNodeJS() {
	return typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]";
}
//#endregion
export { isPlatformNodeJS };

//# sourceMappingURL=platform.is-node.js.map